var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElevatorPitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 73,
    viewBox: "0 0 110 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.2589 6.47217H27.1162V72.808H91.2589V6.47217Z",
    fill: "#0C3A5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2589 6.47217H27.1162V11.8181H91.2589V6.47217Z",
    fill: "#006CAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3765 12.9464H30.3701V72.81H58.3765V12.9464Z",
    fill: "#006CAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0069 12.9464H60.0005V72.81H88.0069V12.9464Z",
    fill: "#006CAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1162 36.6023H21.2012V48.0773H27.1162V36.6023Z",
    fill: "#0C3A5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0975 40.8397H23.2217L24.1457 39.2851L25.0975 40.8397Z",
    fill: "#E43180"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0975 44.0024H23.2217L24.1457 45.559L25.0975 44.0024Z",
    fill: "#E43180"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4382 15.417C32.4382 18.1237 30.8896 20.5944 28.3396 22.4702C28.7619 23.533 34.433 27.4393 34.433 27.4393C34.433 27.4393 25.6587 25.621 24.4709 24.5562C22.0538 25.4941 19.2321 26.0315 16.2181 26.0315C7.26137 26.0315 0 21.2785 0 15.417C0 9.55558 7.26137 4.80258 16.2181 4.80258C25.1748 4.80258 32.4362 9.55558 32.4362 15.417H32.4382Z",
    fill: "#E43180"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3742 32.1309C84.3742 34.2605 85.5936 36.2037 87.5984 37.679C87.2652 38.5158 82.8037 41.5873 82.8037 41.5873C82.8037 41.5873 89.7082 40.1556 90.6401 39.3189C92.5417 40.0565 94.7626 40.4789 97.1321 40.4789C104.179 40.4789 109.892 36.7411 109.892 32.1289C109.892 27.5167 104.179 23.7789 97.1321 23.7789C90.0849 23.7789 84.3722 27.5167 84.3722 32.1289L84.3742 32.1309Z",
    fill: "#E43180"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6883 0H49.063V5.34589H67.6883V0Z",
    fill: "#006CAC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7925 0.543304H50.9585V4.80058H65.7925V0.543304Z",
    fill: "#0C3A5B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6037 1.2532H57.2025C57.3671 1.2532 57.5059 1.31269 57.6229 1.42968C57.7399 1.54667 57.7994 1.68746 57.7994 1.85006V3.34714C57.7994 3.50974 57.7399 3.64854 57.6229 3.76752C57.5059 3.88649 57.3651 3.94399 57.2025 3.94399H56.6037C56.4411 3.94399 56.3003 3.88451 56.1833 3.76752C56.0663 3.65053 56.0068 3.50974 56.0068 3.34714V1.85006C56.0068 1.68746 56.0643 1.54667 56.1833 1.42968C56.3023 1.31269 56.4411 1.2532 56.6037 1.2532ZM57.1986 1.80048C57.1569 1.6359 57.0598 1.5546 56.9051 1.5546C56.8218 1.5546 56.7524 1.58435 56.6929 1.64185C56.6334 1.69936 56.6037 1.77074 56.6037 1.85204V2.86926L57.1986 1.80048ZM56.6116 3.39275C56.6275 3.47603 56.6592 3.53948 56.7068 3.58112C56.7544 3.62277 56.8218 3.64458 56.9031 3.64458C56.9844 3.64458 57.0578 3.61483 57.1153 3.55733C57.1728 3.49784 57.2025 3.42844 57.2025 3.34913V2.33388L56.6096 3.39671L56.6116 3.39275Z",
    fill: "#E43180"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3984 1.2532H60.191V1.85006L60.0403 2.14947L59.8916 2.44889C59.6913 2.86728 59.5921 3.1667 59.5921 3.34516V3.94201H58.9953V3.34516C58.9953 3.14489 59.0944 2.84547 59.2947 2.44889L59.5921 1.85006V1.55262H58.3984V1.2532Z",
    fill: "#E43180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevatorPitch);
export default __webpack_public_path__ + "static/media/elevatorPitch.f9340db601869fd024bbff099a37d1b3.svg";
export { ForwardRef as ReactComponent };